import React from "react";
import { customerInfoConstants } from "../../../constants/inbox.constants";

const { NAME, EMAIL, PHONE } = customerInfoConstants;

const CustomerInfoComponent = ({ name, email, phone }) => {
  const customerDetails = [
    {
      id: 1,
      name: NAME,
      value: name,
    },
    {
      id: 2,
      name: EMAIL,
      value: email,
    },
    {
      id: 3,
      name: PHONE,
      value: phone,
    },
  ];
  return (
    <div className="d-flex flex-column gap-2">
      {customerDetails.map((val) => (
        <div className="d-flex flex-wrap align-items-center" key={val.id}>
          <b className="opacity-50">{val.name}: </b>
          <p
            className="mb-0 text-truncate text-truncate-30ch px-2 bold-6 opacity-75"
            title={val.value}
          >
            {val.value}
          </p>
        </div>
      ))}
    </div>
  );
};

export default React.memo(CustomerInfoComponent);
